export default "__VITE_ASSET__TUElLBFg__"